<template>
  <div>
    <div v-show="!isLoaded">
      <Loading ref="loadingSpinner"></Loading>
    </div>
    <div v-if="isLoaded">
      <b-overlay :show="busy" rounded="sm">
        <ReceivedDeliveriesFilters :filters="filters" @FilterData="getDeliveries" @CleanFilters="CleanUpFilters" />

        <b-row>
          <b-col md="3" sm="3"><b>Produkt</b></b-col>
          <b-col md="3" sm="3"><b>Dostawa</b></b-col>
          <b-col md="3" sm="3"><b>Faktura</b></b-col>
          <b-col md="3" sm="3"><b>Producent</b></b-col>
        </b-row>

        <ReceivedDeliveryItem v-for="item in items" :key="item.id" :deliveryItem="item"
          @RemoveDeliveryItem="RemoveDeliveryFromArray" @OpenModalMaterialLoss="OpenModalMaterialLoss"
          :OpenChangeInvoiceNumberModal="OpenChangeInvoiceNumberModal" />

        <b-row>
          <b-col>
            <b-pagination :total-rows="rows" v-model="filters.currentPage" :per-page="filters.itemsPerPage"
              @change="pageChanged">
            </b-pagination>

          </b-col>
          <b-col>
            <p>Łączne dostawy: {{ totalDeliverySum }} kg</p>
            <p>Łączne użyto: {{ totalUsedWeight }} kg <span v-if="materialLossWeight > 0">w tym strata: {{
              materialLossWeight }} kg</span></p>
          </b-col>
        </b-row>
      </b-overlay>
    </div>

    <MaterialLoss ref="MaterialLossModal" />
    <ChangeInvoiceNumber @InvoiceNumberWasUpdated="UpdateInvoiceNumber" ref="changeInvoiceNumberModal" />
  </div>
</template>

<script>
import axios from "axios";

import Loading from "../../Common/Loading";
import urlConfig from "../../../mixins/url";
import toastr from "../../../mixins/toastr";
import MaterialLoss from "../../Common/MaterialLoss.vue";
import ReceivedDeliveryItem from "./ReceivedDeliveryItem.vue";
import ReceivedDeliveriesFilters from "./ReceivedDeliveriesFilters.vue";
import ChangeInvoiceNumber from './ChangeInvoiceNumber'

export default {
  components: {
    Loading,
    MaterialLoss,
    ReceivedDeliveriesFilters,
    ReceivedDeliveryItem,
    ChangeInvoiceNumber
  },
  mixins: [urlConfig, toastr],
  mounted() {
    this.$store.dispatch("getDeliveryFromData");
    this.getDeliveries();
  },
  computed: {
  },
  data() {
    return {
      busy: false,
      rawMaterialDetails: {},
      updateInvoice: {
        invoiceNumber: "",
        rawMaterialId: 0,
      },
      filters: {
        deliveryDateFrom: null,
        deliveryDateTo: null,
        invoiceDateFrom: null,
        invoiceDateTo: null,
        rawMaterialTypeId: null,
        producerId: null,
        itemsPerPage: 25,
        currentPage: 1,
      },
      items: [],
      totalDeliverySum: 0,
      isLoaded: false,
      rows: 0,
      materialLossWeight: 0,
      totalUsedWeight: 0,
    };
  },
  methods: {
    OpenModalMaterialLoss(item) {
      const modal = this.$refs.MaterialLossModal
      modal.itemId = item.deliveryId;
      modal.itemName = `${item.rawMaterialTypeName} (Seria: ${item.batchNumber})`;
      modal.typeOfLoss = "rawMaterial"
      modal.OpenModal();
    },
    changeLoadingStatus(status) {
      this.isLoaded = !status;
    },
    OpenChangeInvoiceNumberModal(item) {
      this.$refs.changeInvoiceNumberModal.OpenModalForChangingInvoiceNumber(item);
    },
    UpdateInvoiceNumber(updatedInvoice) {
      var rawMaterial = this.items.filter(
        (x) => x.deliveryId == updatedInvoice.rawMaterialDeliveryId
      )[0];
      rawMaterial.invoiceNumber = updatedInvoice.invoiceNumber;
      rawMaterial.invoiceType = 0;
    },

    CleanUpFilters() {
      this.filters = {
        deliveryDateFrom: null,
        deliveryDateTo: null,
        invoiceDateFrom: null,
        invoiceDateTo: null,
        rawMaterialTypeId: null,
        producerId: null,
        itemsPerPage: 25,
        currentPage: 1,
      };
    },
    SetItemsPerPage(itemsCount) {
      this.filters.itemsPerPage = itemsCount;
      this.filters.currentPage = 1;
      this.getDeliveries();
    },
    pageChanged(page) {
      this.filters.currentPage = page;
      this.getDeliveries();
    },
    getDeliveries() {
      var that = this;
      var page = this.filters.currentPage - 1;
      var propertiesToSkip = ["page", "itemsPerPage", "__ob__"];
      that.isLoaded = false;
      var url =
        this.url.serverUrl +
        this.url.Delivery.GetRawMaterialDeliveries +
        page +
        "&itemsPerPage=" +
        this.filters.itemsPerPage +
        "&";

      //TODO do a mising from that filter
      if (this.filters != undefined) {
        var propertyNames = Object.getOwnPropertyNames(this.filters);
        propertyNames.forEach(function (propName) {
          if (!propertiesToSkip.includes(propName)) {
            if (that.filters[propName] != null || that.filters[propName] != undefined) {
              if (typeof that.filters[propName] !== "object") {
                url = url + propName + "=" + that.filters[propName] + "&";
              } else {
                url = url + propName + "=" + that.filters[propName].id + "&";
              }
            }
          }
        });
      }

      axios
        .get(url)
        .then(function (response) {
          that.rows = response.data.totalItemsCount;
          that.items = response.data.rawMaterials;
          that.totalDeliverySum = response.data.totalDeliverySum;
          that.totalUsedWeight = response.data.totalUsedWeight;
          that.materialLossWeight = response.data.totalMaterialLossWeight;
        })
        .catch(function (e) {
          var ref = that.$refs.loadingSpinner;
          ref.ShowErrorMessage(e);
        })
        .finally(function () {
          that.isLoaded = true;
        });
    },
    RemoveDeliveryFromArray(itemId) {
      var index = this.items.findIndex((x) => x.deliveryId == itemId);
      this.items.splice(index, 1);
    }
  },
};
</script>
